var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-options" } },
    [
      _c("or-checkbox", {
        attrs: {
          "data-control": "show-rc-versions",
          "model-value": _vm.settings.showRCVersions,
          label: _vm.$t("HITL.app-launcher.options-show-rc-versions"),
          disabled: _vm.isDisabled,
        },
        on: { "update:modelValue": _vm.onToggleShowRCVersions },
      }),
      _vm._v(" "),
      _c("or-checkbox", {
        attrs: {
          "data-control": "skip-app-launcher",
          "model-value": _vm.settings.skipAppLauncher,
          label: _vm.$t("HITL.app-launcher.options-skip-launcher"),
          disabled: _vm.isDisabled,
        },
        on: { "update:modelValue": _vm.onToggleSkipAppLauncher },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }